import request from "@/utils/request";

export function getLogisticsPage(data,pageNum,pageSize) {
    return request({
        url: `/order/findPage4Logistics`,
        method: 'post',
        params:{pageNum,pageSize},
        data
    })
}
